import React from 'react';
import './style.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";

interface Mybutton{
  children : string,
  onClick?: () => void;
}
export const Button : React.FC<Mybutton> = ({ onClick, children}) => {
  return (
   <div className='global-btn'>
    <button onClick={onClick}>
      {children}
    </button>
   </div> 
  )
  }; 

  export default Button;

